<div class="sc-wrapper">
  <ng-content></ng-content>
</div>
